import { BannerPosition } from '@g99-product-web-ui/shared-interface-lib';

export const TWILIO_BANNER_CONFIG = {
  message:
    'Complete your free 10DLC setup to enable two-way texting for your business.',
  linkText: 'Click here',
  navigateTo: '/business/contact-settings',
  position: BannerPosition.RELATIVE,
};

export const GOOGLE_BANNER_CONFIG = {
  message: 'Your Google Business Profile connection needs to be updated.',
  linkText: 'Reconnect now',
  navigateTo: '/review/location',
  externalLinkText: 'Learn more',
  externalLinkUrl: 'https://support.growth99.com/google-policy',
  position: BannerPosition.RELATIVE,
};

export const TWO_WAY_BANNER_CONFIG = {
  title: 'Two-Way Texting Required',
  message:
    'GIA requires two-way texting to be enabled for your business. Please enable two-way texting in your Contact Settings to activate GIA and start using AI-powered appointment booking and client communication.',
  buttonText: 'Go to Contact Settings',
  navigateTo: '/business/contact-settings',
  position: BannerPosition.RELATIVE,
};

export const GIA_ACTIVATION_BANNER_CONFIG = {
  title: 'GIA Activation Pending',
  subtitle: 'Two-way texting registration required to complete setup',
  buttonText: 'Enable Now',
  navigateTo: '/business/contact-settings',
};
